"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon");
var _style = require("./style");
var _AnimationWrapper = require("../AnimationWrapper");
var _animations = require("../style/animations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ESCAPE_KEY = 27;
const TAB_KEY = 9;
const SimpleModal = _ref => {
  let {
    children,
    closeAction,
    accessibility
  } = _ref;
  const ariaProps = accessibility ? Object.assign({}, accessibility.ariaLabelledby && {
    'aria-labelledby': accessibility.ariaLabelledby,
    'aria-describedby': accessibility.ariaDescribedby
  }) : {};
  const modalRef = (0, _react.useRef)(null);
  const containerRef = (0, _react.useRef)(null);
  const {
    AnimationWrapper,
    dismiss: dismissAnimationWrapper,
    animationProps
  } = (0, _AnimationWrapper.useAnimation)({
    stageInAnimation: _animations.stageInCenter,
    stageOutAnimation: _animations.stageOutCenter,
    duration: 400,
    onDismiss: closeAction
  });
  const handleTabKey = e => {
    const focusableModalElements = modalRef.current.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, div[tabIndex="0"]');
    const firstElement = focusableModalElements[0];
    const lastElement = focusableModalElements[focusableModalElements.length - 1];
    if (!e.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      return e.preventDefault();
    }
    if (e.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      e.preventDefault();
    }
  };
  const keyListenersMap = new Map([[ESCAPE_KEY, dismissAnimationWrapper], [TAB_KEY, handleTabKey]]);
  const clickToClose = e => {
    if (e.target !== containerRef.current) return;
    dismissAnimationWrapper();
  };
  (0, _react.useEffect)(() => {
    function keyListener(e) {
      const listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    }
    document.addEventListener('keydown', keyListener);
    modalRef.current.focus();
    containerRef.current.addEventListener('click', e => clickToClose(e));
    return () => document.removeEventListener('keydown', keyListener);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_style.Container, Object.assign({
    ref: containerRef,
    role: "dialog",
    "aria-modal": "true"
  }, ariaProps), /*#__PURE__*/_react.default.createElement(AnimationWrapper, Object.assign({}, animationProps), /*#__PURE__*/_react.default.createElement(_style.Modal, {
    ref: modalRef,
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement(_style.CloseButton, {
    onClick: () => dismissAnimationWrapper(),
    "aria-label": "Close",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Cross, null)), children)));
};
SimpleModal.propTypes = {
  children: _propTypes.default.node.isRequired,
  closeAction: _propTypes.default.func.isRequired,
  accessibility: _propTypes.default.shape({
    ariaLabelledby: _propTypes.default.string,
    ariaDescribedby: _propTypes.default.string
  })
};
var _default = exports.default = SimpleModal;